// Triggers a browser download of `data` as a JSON file. A string is already
// serialized JSON and is written verbatim — the producer decides whether it is
// pretty or compact; anything else is pretty-printed.
export const downloadJson = (filename: string, data: unknown) => {
  const text = typeof data === "string" ? data : JSON.stringify(data, null, 2);
  const blob = new Blob([text], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
